import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";
import { useMemo } from "react";

import { fetchFilterOptions } from "../slices/filterOptionsSlice";

export const useGetVehiclesFiltersWithOptions = (filters, token) => {
    const dispatch = useDispatch();
    const options = useSelector((state) => state.filterOptions.options);
    const status = useSelector((state) => state.filterOptions.loadingStatus);

    useEffect(() => {
        if (!filters || !token) return;

        Object.entries(filters).forEach(([filterKey, config]) => {
            if (typeof config.options === 'string') {
                dispatch(fetchFilterOptions({
                    filterKey,
                    url: config.options,
                    token
                }));
            }
        });
    }, [filters, token, dispatch]);

    const hydratedFilters = useMemo(() => {
        if (!filters) return [];

        return Object.entries(filters).map(([filterKey, filter]) => ({
            ...filter,
            filterKey,
            hydratedOptions: options[filterKey] || []
        }));
    }, [filters, options]);

    const loading = Object.values(status).some(s => s === "loading");

    return { filters: hydratedFilters, loading };
}